import { borerShiftAdvanceFamilyMember } from '../Advance/borerShiftAdvanceFamilyMember';
import { assignmentFamilyMember } from '../Assignment/assignmentFamilyMember';
import { assignmentEmployeeFamilyMember } from '../AssignmentEmployee/assignmentEmployeeFamilyMember';
import { assignmentRoleFamilyMember } from '../AssignmentRole/assignmentRoleFamilyMember';
import { blocksFamilyMember } from '../Blocks/blocksFamilyMember';
import { borerActivityFamilyMember } from '../BorerActivity/borerActivityFamilyMember';
import { borerActivityTypeFamilyMember } from '../BorerActivityType/borerActivityTypeFamilyMember';
import { borerDocumentUploadFamilyMember } from '../BorerDocuments/borerDocumentUploadFamilyMember';
import { borerShiftFamilyMember } from '../BorerShift/borerShiftFamilyMember';
import { borerShiftActivityEmployeesFamilyMember } from '../BorerShiftActivityEmployees/borerShiftActivityEmployeesFamilyMember';
import { borerShiftCommentFamilyMember } from '../BorerShiftComment/borerShiftCommentFamilyMember';
import { borerShiftCommentTypeFamilyMember } from '../BorerShiftCommentType/borerShiftCommentTypeFamilyMember';
import { borerShiftCrewFamilyMember } from '../BorerShiftCrew/borerShiftCrewFamilyMember';
import { borerShiftCrewMemberFamilyMember } from '../BorerShiftCrewMember/borerShiftCrewMemberFamilyMember';
import { borerShiftCrewMemberRoleFamilyMember } from '../BorerShiftCrewMemberRole/borerShiftCrewMemberRoleFamilyMember';
import { borerShiftInfoFamilyMember } from '../BorerShiftInfo/borerShiftInfoFamilyMember';
import { borerShiftSignatureFamilyMember } from '../BorerShiftSignature/borerShiftSignatureFamilyMember';
import { borerShiftTargetFamilyMember } from '../BorerShiftTarget/borerShiftTargetFamilyMember';
import { borerStateTypeCategoryFamilyMember } from '../BorerStateTypeCategory/borerStateTypeCategoryFamilyMember';
import { borerStateTypeFamilyMember } from '../BorerStateTypeFeed/borerStateTypeFamilyMember';
import { crewsFamilyMember } from '../Crew/crewsFamilyMember';
import { cuttingMethodFamilyMember } from '../CuttingMethod/cuttingMethodFamilyMember';
import { cuttingPermitSupervisorCommentFamilyMember } from '../CuttingPermitSupervisorComment/cuttingPermitSupervisorCommentFamilyMember';
import { cuttingTypeFamilyMember } from '../CuttingType/cuttingTypeFamilyMember';
import { dailySafetyTopicFamilyMember } from '../DailySafetyTopic/dailySafetyTopicFamilyMember';
import { delayActivityTypeCategoryFamilyMember } from '../DelayActivityTypeCategory/delayActivityTypeCategoryFamilyMember';
import { departmentFamilyMember } from '../Department/departmentFamilyMember';
import { documentUploadFamilyMember } from '../Documents/documentUploadFamilyMember';
import { documentTypesFamilyMember } from '../DocumentTypes/documentTypesFamilyMember';
import { employeesFamilyMember } from '../Employees/employeesFamilyMember';
import { equipmentFamilyMember } from '../Equipment/equipmentFamilyMember';
import { equipmentDeficiencyFamilyMember } from '../EquipmentDeficiency/equipmentDeficiencyFamilyMember';
import { equipmentDeficiencyAttachmentFamilyMember } from '../EquipmentDeficiencyAttachments/equipmentDeficiencyAttachmentFamilyMember';
import { equipmentDeficiencyLogFamilyMember } from '../EquipmentDeficiencyLog/equipmentDeficiencyLogFamilyMember';
import { equipmentStatusFamilyMember } from '../EquipmentStatus/equipmentStatusFamilyMember';
import { equipmentTypeFamilyMember } from '../EquipmentType/equipmentTypeFamilyMember';
import { groundControlSetsFamilyMember } from '../GroundControlSet/groundControlSetsFamilyMember';
import { groundControlTypesFamilyMember } from '../GroundControlTypes/groundControlTypesFamilyMember';
import { groundHazardsFamilyMember } from '../GroundHazard/groundHazardsFamilyMember';
import { groundHazardAttachmentsFamilyMember } from '../GroundHazardAttachment/groundHazardAttachmentsFamilyMember';
import { hazardLogsFamilyMember } from '../GroundHazardLog/hazardLogsFamilyMember';
import { groundHazardConditionTypesFamilyMember } from '../HazardConditionType/groundHazardConditionTypesFamilyMember';
import { hazardSeveritiesFamilyMember } from '../HazardSeverities/hazardSeveritiesFamilyMember';
import { inspectionCategoriesFamilyMember } from '../InspectionCategories/inspectionCategoriesFamilyMember';
import { inspectionOptionsFamilyMember } from '../InspectionOptions/inspectionOptionsFamilyMember';
import { inspectionResultsFamilyMember } from '../InspectionResults/inspectionResultsFamilyMember';
import { inspectionsFamilyMember } from '../Inspections/inspectionsFamilyMember';
import { inspectionSeverityFamilyMember } from '../InspectionSeverityFeed/inspectionSeverityFamilyMember';
import { locationsFamilyMember } from '../Locations/locationsFamilyMember';
import { miningCutsFamilyMember } from '../MiningCut/miningCutsFamilyMember';
import { miningPatternFamilyMember } from '../MiningPattern/miningPatternFamilyMember';
import { panelDrawingsFamilyMember } from '../PanelDrawing/panelDrawingsFamilyMember';
import { panelDrawingCommentsFamilyMember } from '../PanelDrawingComment/panelDrawingCommentsFamilyMember';
import { panelLogsFamilyMember } from '../PanelLog/panelLogsFamilyMember';
import { panelsFamilyMember } from '../Panels/panelsFamilyMember';
import { passesFamilyMember } from '../Passes/passesFamilyMember';
import { positionsFamilyMember } from '../Position/positionsFamilyMember';
import { borerShiftPredictionFamilyMember } from '../Prediction/borerShiftPredictionFamilyMember';
import { borerShiftProductionFamilyMember } from '../Productions/borerShiftProductionFamilyMember';
import { roomsFamilyMember } from '../Rooms/roomsFamilyMember';
import { sequencesFamilyMember } from '../Sequences/sequencesFamilyMember';
import { serviceStatusFamilyMember } from '../ServiceStatus/serviceStatusFamilyMember';
import { shiftFamilyMember } from '../Shifts/shiftFamilyMember';
import { signaturesFamilyMember } from '../Signature/signaturesFamilyMember';
import { sitesFamilyMember } from '../Site/sitesFamilyMember';
import { suppliesFamilyMember } from '../Supply/suppliesFamilyMember';
import { supplyItemsFamilyMember } from '../SupplyItem/supplyItemsFamilyMember';
import { surveyPointsFamilyMember } from '../SurveyPoints/surveyPointsFamilyMember';
import { targetBorerRunningTimesFamilyMember } from '../TargetBorerRunningTimes/targetBorerRunningTimesFamilyMember';
import { workOrdersFamilyMember } from '../WorkOrders/workOrderFamilyMember';
import { handleOperatorStateFeedEvents } from './BorerOperator/handleOperatorStateFeedEvents';
import { borerOperatorChangeFeedFamilyMember } from './BorerOperatorChangeFeed/replicateBorerOperatorChange';
import { borerOperatorStateFeedFamilyMember } from './BorerOperatorStateFeed/replicateBorerOperatorState';
import { Database } from './Database';
import { create } from './Family/create';
import { Family } from './Family/Family';
import { createConfigBuilder } from './replicate';

export function createFamilies(database: Database, idToken: string): Family[] {
  const configBuilder = createConfigBuilder(idToken, database);
  const families: Family[] = [];

  // First Order collections
  const equipmentType = equipmentTypeFamilyMember(configBuilder);
  const sites = sitesFamilyMember(configBuilder);

  // Second Order collections
  const assignmentRole = assignmentRoleFamilyMember(configBuilder, sites);
  const blocks = blocksFamilyMember(configBuilder, sites);
  const borerShiftCommentType = borerShiftCommentTypeFamilyMember(configBuilder, sites);
  const borerShiftCrewMemberRole = borerShiftCrewMemberRoleFamilyMember(configBuilder, sites);
  const borerStateTypeCategory = borerStateTypeCategoryFamilyMember(configBuilder, sites);
  const cuttingMethod = cuttingMethodFamilyMember(configBuilder, sites);
  const cuttingType = cuttingTypeFamilyMember(configBuilder, sites);
  const dailySafetyTopic = dailySafetyTopicFamilyMember(configBuilder, sites);
  const delayActivityTypeCategory = delayActivityTypeCategoryFamilyMember(configBuilder, sites);
  const department = departmentFamilyMember(configBuilder, sites);
  const documentTypes = documentTypesFamilyMember(configBuilder, sites);
  const equipmentStatus = equipmentStatusFamilyMember(configBuilder, sites);
  const groundControlTypes = groundControlTypesFamilyMember(configBuilder, sites);
  const hazardSeverities = hazardSeveritiesFamilyMember(configBuilder, sites);
  const inspections = inspectionsFamilyMember(configBuilder, sites);
  const miningPattern = miningPatternFamilyMember(configBuilder, sites);
  const passes = passesFamilyMember(configBuilder, sites);
  const positions = positionsFamilyMember(configBuilder, sites);
  const sequences = sequencesFamilyMember(configBuilder, sites);
  const serviceStatus = serviceStatusFamilyMember(configBuilder, sites);
  const shift = shiftFamilyMember(configBuilder, sites);
  const supplyItems = supplyItemsFamilyMember(configBuilder, sites);

  // Third Order collections
  const borerActivityType = borerActivityTypeFamilyMember(
    configBuilder,
    delayActivityTypeCategory,
    sites,
  );
  const borerStateType = borerStateTypeFamilyMember(
    configBuilder,
    borerStateTypeCategory,
    equipmentType,
    sites,
  );
  const crews = crewsFamilyMember(configBuilder, department, sites);
  const groundControlSets = groundControlSetsFamilyMember(configBuilder, groundControlTypes);
  const groundHazardConditionTypes = groundHazardConditionTypesFamilyMember(
    configBuilder,
    hazardSeverities,
  );
  const inspectionCategories = inspectionCategoriesFamilyMember(configBuilder, inspections);
  const inspectionSeverity = inspectionSeverityFamilyMember(configBuilder, inspections, sites);
  const miningCuts = miningCutsFamilyMember(configBuilder, miningPattern, passes, sequences, sites);
  const panels = panelsFamilyMember(configBuilder, blocks, sites);
  const rooms = roomsFamilyMember(configBuilder, miningPattern, panels, sites);
  const surveyPoints = surveyPointsFamilyMember(configBuilder, miningPattern, rooms, sites);

  // Fourth Order collections
  const assignment = assignmentFamilyMember(configBuilder, crews, shift);
  const documentUpload = documentUploadFamilyMember(
    configBuilder,
    documentTypes,
    rooms,
    sites,
    surveyPoints,
  );
  const employees = employeesFamilyMember(configBuilder, crews, department, positions, sites);
  const equipment = equipmentFamilyMember(
    configBuilder,
    blocks,
    department,
    equipmentStatus,
    equipmentType,
    panels,
    rooms,
    sites,
    surveyPoints,
  );
  const inspectionOptions = inspectionOptionsFamilyMember(
    configBuilder,
    equipmentType,
    inspectionCategories,
  );
  const locations = locationsFamilyMember(
    configBuilder,
    panels,
    passes,
    rooms,
    sequences,
    surveyPoints,
  );

  // Fifth Order collections
  const assignmentEmployee = assignmentEmployeeFamilyMember(
    configBuilder,
    assignment,
    assignmentRole,
    employees,
  );
  const borerShift = borerShiftFamilyMember(configBuilder, equipment, shift, sites);
  const borerDocumentUpload = borerDocumentUploadFamilyMember(
    configBuilder,
    documentTypes,
    equipment,
    sites,
  );
  const equipmentDeficiency = equipmentDeficiencyFamilyMember(
    configBuilder,
    employees,
    equipment,
    sites,
  );
  const groundHazards = groundHazardsFamilyMember(configBuilder, equipment, inspections, locations);
  const panelLogs = panelLogsFamilyMember(configBuilder, employees, equipment, panels);
  const signatures = signaturesFamilyMember(configBuilder, employees);
  const supplies = suppliesFamilyMember(configBuilder, equipment, supplyItems);
  const targetBorerRunningTimes = targetBorerRunningTimesFamilyMember(
    configBuilder,
    equipment,
    sites,
  );
  const workOrders = workOrdersFamilyMember(configBuilder, equipment, sites);

  // Sixth Order collections
  const borerShiftComment = borerShiftCommentFamilyMember(
    configBuilder,
    borerShift,
    borerShiftCommentType,
  );
  const borerShiftCrew = borerShiftCrewFamilyMember(configBuilder, borerShift);
  const borerShiftInfo = borerShiftInfoFamilyMember(
    configBuilder,
    borerShift,
    panels,
    serviceStatus,
  );
  const borerShiftPrediction = borerShiftPredictionFamilyMember(
    configBuilder,
    borerShift,
    locations,
  );
  const borerShiftProduction = borerShiftProductionFamilyMember(
    configBuilder,
    borerShift,
    equipment,
    locations,
    miningCuts,
  );
  const borerShiftSignature = borerShiftSignatureFamilyMember(
    configBuilder,
    borerShift,
    signatures,
  );
  const borerShiftTarget = borerShiftTargetFamilyMember(
    configBuilder,
    borerShift,
    equipment,
    sites,
  );
  const equipmentDeficiencyAttachment = equipmentDeficiencyAttachmentFamilyMember(
    configBuilder,
    equipmentDeficiency,
  );
  const equipmentDeficiencyLog = equipmentDeficiencyLogFamilyMember(
    configBuilder,
    equipmentDeficiency,
  );
  const groundHazardAttachments = groundHazardAttachmentsFamilyMember(configBuilder, groundHazards);
  const hazardLogs = hazardLogsFamilyMember(
    configBuilder,
    groundControlSets,
    groundHazards,
    employees,
  );
  const inspectionResults = inspectionResultsFamilyMember(
    configBuilder,
    borerShift,
    inspections,
    locations,
    signatures,
  );
  const panelDrawings = panelDrawingsFamilyMember(configBuilder, borerShift);

  // Seventh Order collections
  const borerActivity = borerActivityFamilyMember(
    configBuilder,
    borerActivityType,
    borerShift,
    borerShiftCrew,
  );
  const borerShiftAdvance = borerShiftAdvanceFamilyMember(configBuilder, borerShiftProduction);
  const borerShiftCrewMember = borerShiftCrewMemberFamilyMember(
    configBuilder,
    borerShiftCrew,
    borerShiftCrewMemberRole,
    employees,
  );
  const cuttingPermitSupervisorComment = cuttingPermitSupervisorCommentFamilyMember(
    configBuilder,
    inspectionResults,
    signatures,
  );
  const panelDrawingComments = panelDrawingCommentsFamilyMember(configBuilder, panelDrawings);

  // Eighth Order collections
  const borerOperatorStateFeed = borerOperatorStateFeedFamilyMember(
    configBuilder,
    borerShift,
    borerShiftAdvance,
    borerStateType,
    cuttingMethod,
    cuttingType,
    equipment,
  );
  const borerOperatorChangeFeed = borerOperatorChangeFeedFamilyMember(
    configBuilder,
    borerShift,
    borerShiftAdvance,
    borerStateType,
    cuttingMethod,
    cuttingType,
    equipment,
  );
  const borerShiftActivityEmployees = borerShiftActivityEmployeesFamilyMember(
    configBuilder,
    borerActivity,
    employees,
  );

  handleOperatorStateFeedEvents(
    borerOperatorStateFeed.replicationState,
    borerOperatorChangeFeed.replicationState,
    database,
  );

  families.push(
    create('Everything', {
      assignment_employee: assignmentEmployee,
      assignment_role: assignmentRole,
      assignment,
      blocks,
      borer_activity_type: borerActivityType,
      borer_activity: borerActivity,
      borer_document_upload: borerDocumentUpload,
      borer_operator_change_feed: borerOperatorChangeFeed,
      borer_operator_state_feed: borerOperatorStateFeed,
      borer_shift_activity_employees: borerShiftActivityEmployees,
      borer_shift_advance: borerShiftAdvance,
      borer_shift_comment_type: borerShiftCommentType,
      borer_shift_comment: borerShiftComment,
      borer_shift_crew_member_role: borerShiftCrewMemberRole,
      borer_shift_crew_member: borerShiftCrewMember,
      borer_shift_crew: borerShiftCrew,
      borer_shift_info: borerShiftInfo,
      borer_shift_prediction: borerShiftPrediction,
      borer_shift_production: borerShiftProduction,
      borer_shift_signature: borerShiftSignature,
      borer_shift_target: borerShiftTarget,
      borer_shift: borerShift,
      borer_state_type_category: borerStateTypeCategory,
      borer_state_type: borerStateType,
      crews,
      cutting_method: cuttingMethod,
      cutting_permit_supervisor_comment: cuttingPermitSupervisorComment,
      cutting_type: cuttingType,
      daily_safety_topic: dailySafetyTopic,
      delay_activity_type_category: delayActivityTypeCategory,
      department,
      document_types: documentTypes,
      document_upload: documentUpload,
      employees,
      equipment_deficiency_attachment: equipmentDeficiencyAttachment,
      equipment_deficiency_log: equipmentDeficiencyLog,
      equipment_deficiency: equipmentDeficiency,
      equipment_status: equipmentStatus,
      equipment_type: equipmentType,
      equipment,
      ground_control_sets: groundControlSets,
      ground_control_types: groundControlTypes,
      ground_hazard_attachments: groundHazardAttachments,
      ground_hazard_condition_types: groundHazardConditionTypes,
      ground_hazards: groundHazards,
      hazard_logs: hazardLogs,
      hazard_severities: hazardSeverities,
      inspection_categories: inspectionCategories,
      inspection_options: inspectionOptions,
      inspection_results: inspectionResults,
      inspection_severity: inspectionSeverity,
      inspections,
      locations,
      mining_cuts: miningCuts,
      mining_pattern: miningPattern,
      panel_drawing_comments: panelDrawingComments,
      panel_drawings: panelDrawings,
      panel_logs: panelLogs,
      panels,
      passes,
      positions,
      rooms,
      sequences,
      service_status: serviceStatus,
      shift,
      signatures,
      sites,
      supplies,
      supply_items: supplyItems,
      survey_points: surveyPoints,
      target_borer_running_times: targetBorerRunningTimes,
      work_orders: workOrders,
    }),
  );

  return families;
}
